import { ApiPromise } from '@/types';
import { HTTP } from '@/utils';

export default class PeopleTypesService {
  static resource = 'people-types';

  static getPeopleTypes(params?: Record<string, unknown>): ApiPromise {
    const query = params ? `?${new URLSearchParams(params as Record<string, string>).toString()}` : '';
    return HTTP.get(`${this.resource}${query}`);
  }
}
